'use client';
import React from 'react';
import { CmsComponentProps } from '../../types';
import { Summary } from './Summary';
import { ComponentTableOfContents } from '$/(cms)/_modules/cmsService/types';

type TableOfContentsProps = ComponentTableOfContents & {
  components: CmsComponentProps[];
};

export const resolveTableOfContentsAnchorId = ({
  itemAnchor,
  index,
  tableBuilderAnchorIds,
}: {
  itemAnchor?: string;
  index?: number;
  tableBuilderAnchorIds: Set<string>;
}) => {
  const trimmedAnchor = itemAnchor?.trim();

  if (!trimmedAnchor) {
    return index === undefined ? 'content' : `content-${index}`;
  }

  return tableBuilderAnchorIds.has(trimmedAnchor)
    ? trimmedAnchor
    : `anchor-${trimmedAnchor}`;
};

export const TableOfContents: React.FC<TableOfContentsProps> = ({
  selected_blocks,
  titleReq,
  listType,
  collapsible,
  collapsed_default,
  components,
}) => {
  const tableBuilderAnchorIds = React.useMemo(
    () =>
      new Set(
        components
          .filter(
            (
              component,
            ): component is Extract<
              CmsComponentProps,
              { __typename: 'ComponentPagesComponentTableBuilderComponent' }
            > =>
              component.__typename ===
              'ComponentPagesComponentTableBuilderComponent',
          )
          .map((component) => component.anchorId?.trim())
          .filter((anchorId): anchorId is string => Boolean(anchorId)),
      ),
    [components],
  );

  const items =
    selected_blocks?.map((c) => ({
      id: c?.index,
      title: c?.link_text,
      description: c?.description,
      anchorId: resolveTableOfContentsAnchorId({
        itemAnchor: c?.item_acnhor,
        index: c?.index,
        tableBuilderAnchorIds,
      }),
    })) ?? [];

  return (
    <Summary
      title={titleReq}
      collapsible={collapsible}
      collapsedDefault={collapsed_default}
      listType={listType}
      items={items}
    />
  );
};
